import {
  AnalyticsSiteAssets,
  DataLayerAnalytics,
  Page,
  setAdobeAnalytics
} from '@com-delta-idp/mnx-skymiles-landing-page-ui';
import { SummaryAnalyticsEvent } from '@com-delta-idp/mnx-skymiles-shared';
import { DATA_ANALYTICS, USER_LOGGED_IN_STATUS } from '../models';
import {
  BannerClickEvent,
  BannerClickEventData
} from '../models/analytics/banner-click.interfaces';
import { removeUndefinedSiteAsset } from '../services/analytics/data-layer-click.utils';
import { getPageLoadTime } from './analytics.utils';

export const setupBannerClickListeners = (): void => {
  const events = [
    'micro_moment_click',
    'fast_action_banner_click',
    'upgrade_card_click',
    'skyclub spend tracker terms click',
    'Search eligible Sky Clubs',
    'upgrade_view_all',
    'tooltip'
  ];

  events.forEach((eventName) => {
    document.addEventListener(eventName, (event: Event) => {
      const bannerEvent = event as BannerClickEvent;
      handleBannerClick(bannerEvent.detail);
    });
  });
};

export const handleBannerClick = (eventData: string): void => {
  const data: BannerClickEventData = JSON.parse(eventData);
  const selectedAsset = data.assets?.find((asset) => asset.id === data.id);

  let analyticsData: DataLayerAnalytics = {
    event_detail: data.eventName ? data.eventName : 'banner link click',
    event: 'click',
    user: {
      attributes: {
        is_logged_in: USER_LOGGED_IN_STATUS.AUTHENTICATED
      }
    },
    click: getClickProperties(data),
    site_assets: [selectedAsset]
  };
  analyticsData = removeUndefinedSiteAsset(analyticsData);

  setAdobeAnalytics(analyticsData);
};

const getClickProperties = (data: BannerClickEventData) => {
  return {
    name: data.name,
    type: data.type ?? 'link',
    page_section: data.pageSection ?? 'banner',
    page_subsection: data.subSection ?? '',
    action: data.link,
    component_name: data.component_name,
    component_type: data.component_type
  };
};

export const setLinkClickAnalytics = (
  data: SummaryAnalyticsEvent,
  assets: AnalyticsSiteAssets[],
  page: Page
): void => {
  const selectedAsset = assets.find((asset) => asset.id === data.id);
  let analyticsData: DataLayerAnalytics = {
    event_detail: getEventData(data.eventType),
    event: getEventData(data.event),
    click: {
      name: data.action?.label,
      type: 'link',
      page_section: data.pageSection
        ? data.pageSection
        : 'skymiles overview tracker',
      action: data.action?.url
    },
    user: {
      attributes: {
        is_logged_in: 'authenticated'
      }
    },
    site_assets: isSiteAsset(data) ? [selectedAsset] : undefined
  };
  if (data.type === 'modal') {
    delete analyticsData.click;
    analyticsData.page = page;
    analyticsData.page.info.subpage_name = DATA_ANALYTICS.EARNING_TITLE;
    analyticsData.page.info.subpage_type = DATA_ANALYTICS.MODAL;
  }
  analyticsData = removeUndefinedSiteAsset(analyticsData);
  setAdobeAnalytics(analyticsData);
};

const getEventData = (eventType: string) => eventType ?? 'click';

const isSiteAsset = (data: SummaryAnalyticsEvent): boolean =>
  data.id === 'millionmilerstatus' ||
  data.id === 'snapshot' ||
  data.id === 'milesavailable';

export const updateSiteAssets = (
  analyticsData: DataLayerAnalytics,
  assets: AnalyticsSiteAssets[],
  pageLoadStart: number
): void => {
  const updatedAnalyticsData = {
    ...analyticsData,
    page: {
      info: {
        ...analyticsData.page.info,
        page_load_time: getPageLoadTime(pageLoadStart)
      }
    },
    site_assets: assets
  };
  const analyticsDataWithAssets = { ...updatedAnalyticsData };
  delete analyticsDataWithAssets.error;
  setAdobeAnalytics(analyticsDataWithAssets);
};
